import Trail from './Trail';

export default Trail;
